module.exports = __webpack_public_path__ + "img/Academy.72a02ecf.svg";